import rig from '../../internal/assets/bento-rows.json';

export const ATTACHMENT_JOINTS = rig.rows.map(row => row.split('|')[0]!);
export const MAX_ATTACHMENTS_PER_JOINT = 4;
export const MAX_ATTACHMENTS = 50;
export function withinJointLimits(attachments: readonly {joint: string}[]): boolean {
  const counts = new Map<string, number>();
  return attachments.every(({joint}) => {
    const count = (counts.get(joint) ?? 0) + 1;
    counts.set(joint, count);
    return count <= MAX_ATTACHMENTS_PER_JOINT;
  });
}
